import { ChemicalOrderPortCallBM } from '../../types/BusinessModel/TankCleaning/ChemicalOrderPortCallBM';
import { ChemicalOrderPortCall } from '../../types/ViewModel/TankCleaning/Order/ChemicalOrderPortCall';
import { createChemicalOrderItemList } from './ChemicalOrderItemFactory';

export const createChemicalOrderPortCall = (chemicalOrderPortCall: ChemicalOrderPortCallBM): ChemicalOrderPortCall => {
    return {
        chemicalOrderId: chemicalOrderPortCall.chemicalOrderId,
        parentOrderId: chemicalOrderPortCall.parentOrderId,
        portCallId: chemicalOrderPortCall.portCallId,
        imoNumber: chemicalOrderPortCall.imoNumber,
        orderLocation: chemicalOrderPortCall.orderLocation,
        deliveryPortCallId: chemicalOrderPortCall.deliveryPortCallId,
        deliveryLocation: chemicalOrderPortCall.deliveryLocation,
        portArrivalDateLocalTime: chemicalOrderPortCall.portArrivalDateLocalTime,
        orcaWebUrl: chemicalOrderPortCall.orcaWebUrl,
        lastOrderStatusId: chemicalOrderPortCall.lastOrderStatusId,
        updateOrderStatusId: chemicalOrderPortCall.updateOrderStatusId,
        voyageNumber: chemicalOrderPortCall.voyageNumber,
        createdBy: chemicalOrderPortCall.createdBy,
        createdUtc: chemicalOrderPortCall.createdUtc,
        lastUpdatedBy: chemicalOrderPortCall.lastUpdatedBy,
        lastUpdatedUtc: chemicalOrderPortCall.lastUpdatedUtc,
        chemicalOrderItemList: createChemicalOrderItemList(chemicalOrderPortCall.chemicalOrderItemList),
        chemicalOrderStatusList: [],
    };
};

export const createChemicalOrderPortCallList = (chemicalOrderPortCallList: ChemicalOrderPortCallBM[]) =>
    chemicalOrderPortCallList?.map((chemicalOrderPortCall) => createChemicalOrderPortCall(chemicalOrderPortCall));
